import * as types from '../constants/ActionTypes';
import * as endPoints from '../constants/EndPoints';
import { fetchMiddleware, setIndexes } from './MiddlewareActions';

const requestDistributors = () => ({
  type: types.REQUEST_DISTRIBUTORS,
});

const receiveDistributors = (items, indexMap, optionsList) => ({
  type: types.RECEIVE_DISTRIBUTORS,
  items,
  indexMap,
  optionsList,
});

export const fetchDistributors = () => (dispatch, getState) => {
  const path = endPoints.DISTRIBUTORS_ENDPOINT;
  dispatch(requestDistributors());
  return fetchMiddleware(path, {}, getState).then((json) => {
    const items = json.data || [];
    const indexMap = setIndexes(items, 'ID');
    const optionsList = items.map((distributor) => ({
      value: distributor.ID,
      label: distributor.Name,
    }));
    return dispatch(receiveDistributors(items, indexMap, optionsList));
  });
};
